import type { HostKind } from "../components/primitives";

export function buildCursorInstallUrl(mcpEndpoint: string): string {
  const config = {
    command: "npx",
    args: ["-y", "mcp-remote", mcpEndpoint],
  };
  const b64 = btoa(JSON.stringify(config));
  return `cursor://anysphere.cursor-deeplink/mcp/install?name=kuvio&config=${b64}`;
}

export function buildBriefingPrompt(agentName: string): string {
  return `Operate as the ${agentName} agent in my Kuvio workspace. Brief me on what's on my plate today using the agent-briefing prompt.`;
}

export function launchCursor(mcpEndpoint: string): void {
  const url = buildCursorInstallUrl(mcpEndpoint);
  window.open(url, "_self");
}

export function launchCowork(briefing?: string): void {
  const base = "https://claude.ai/new";
  const url = briefing ? `${base}?q=${encodeURIComponent(briefing)}` : base;
  window.open(url, "_blank");
}

export function launchClaudeWeb(briefing?: string): void {
  const base = "https://claude.ai/new";
  const url = briefing ? `${base}?q=${encodeURIComponent(briefing)}` : base;
  window.open(url, "_blank");
}

export function launchClaudeCode(briefing?: string): void {
  if (briefing) {
    navigator.clipboard.writeText(briefing).catch(() => {});
  }
  window.open("https://claude.ai/code", "_blank");
}

export function launchChatGPT(briefing?: string): void {
  if (briefing) {
    navigator.clipboard.writeText(briefing).catch(() => {});
  }
  window.open("https://chatgpt.com/", "_blank");
}

export function launchHost(
  host: HostKind,
  opts: { mcpEndpoint: string; briefing?: string },
): void {
  switch (host) {
    case "cursor":
      return launchCursor(opts.mcpEndpoint);
    case "cowork":
      return launchCowork(opts.briefing);
    case "claude-web":
      return launchClaudeWeb(opts.briefing);
    case "claude-code":
      return launchClaudeCode(opts.briefing);
    case "chatgpt":
      return launchChatGPT(opts.briefing);
    default:
      break;
  }
}

export function formatLastSeen(iso: string | null | undefined): string {
  if (!iso) return "never";
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 0) return "just now";
  const mins = Math.floor(ms / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "yesterday";
  return `${days} days ago`;
}
